import React from 'react'
import Recharges from './Recharges'

const Checker = () => {
    return (
        <Recharges />
    )
}

export default Checker